var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 595.28 841.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f8f8f8}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m592.78,0c-31.5,13.38-59.36,35.17-79.68,62.9-15.4,21.01-25.88,45.51-37.74,68.59-13.29,25.86-26.29,51.86-39.47,77.77-26.54,52.14-53.07,104.29-79.52,156.48-13.34,26.32-26.58,52.7-39.92,79.02-3.66,7.21-7.31,14.42-10.97,21.63-1.16,2.28-5.11,13.16-7.33,13.71-3.4.85-14.72-26.47-16.9-30.75-52.76-103.68-105.77-207.23-158.14-311.1-23.34-46.3-43.86-92.13-88.27-122.03C25.49,9.93,15.65,4.52,5.45,0H0v317.4c42.96,84.71,85.98,169.38,128.86,254.13,26.72,52.81,53.57,105.55,80.38,158.32,13.07,25.74,26.08,51.51,39.14,77.25,5.88,11.59,11.76,23.19,17.62,34.8h63.09c5.18-10.29,10.39-20.56,15.6-30.82,83.67-164.65,166.93-329.51,250.59-494.17V0h-2.49Z",
    className: "cls-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVBackground);
export default __webpack_public_path__ + "static/media/v_background.171130d510b4b8310f5700bc6ef96677.svg";
export { ForwardRef as ReactComponent };